import { Ecommerce, EventNamesList, Taxonomy } from 'shared/tracking/contracts';
import { mapTracking } from './mapTracking';

export type TrackSegmentFunction = (
    eventName: EventNamesList,
    taxonomy?: Taxonomy,
    ecommerce?: Ecommerce
) => void;

export const trackEvent: TrackSegmentFunction = (
    eventName: EventNamesList,
    taxonomy?: Taxonomy,
    ecommerce?: Ecommerce
) => {
    const eventData = mapTracking(taxonomy, ecommerce);

    if (!eventData) return;

    window.analytics?.track(eventName, eventData);
};
